<template>
    <div class="container content-field">
        <div class="card">
            <div class="card-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
</script>

<style scoped>
.content-field {
    margin-top: 24px;
    margin-bottom: 28px;
}

.card {
    border-radius: var(--app-radius-lg);
}

.card-body {
    background: transparent;
    padding: 24px;
}

@media (max-width: 768px) {
    .content-field {
        margin-top: 16px;
    }

    .card-body {
        padding: 16px;
    }
}
</style>
